module.exports = __webpack_public_path__ + "static/media/Project-Banking.f7ca7360.svg";